import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { bidsModalHide, updateNftBids } from "../../redux/marketplaceSlice";
import {
  useCosmWasmClient,
  useSigningCosmWasmClient,
  useWallet,
  WalletConnectButton,
} from "@sei-js/react";
import { toast } from "react-toastify";
import { makeBidHandle } from "../../api/index"
import {
  createBid,
  updateListing,
  deleteListing,
  buy,
  getBids
} from "../../utils/api";

const DECIMAL = 1000000;

const BidsModal = () => {
  const { bidsModal, bidData, seiPrice, nftBids } = useSelector((state) => state.marketplace);
  const dispatch = useDispatch();
  const [bidAmount, setBidAmount] = useState(0.00);
  const [checkedTerm, setCheckedTerm] = useState(false);
  const [balance, setBalance] = useState(0);
  const [loading, setLoading] = useState(false);
  const { connectedWallet, accounts, disconnect } = useWallet();
  const { cosmWasmClient: queryClient } = useCosmWasmClient();
  const { signingCosmWasmClient: signingClient } = useSigningCosmWasmClient();

  const handleBidAmount = (e) => {
    e.preventDefault();
    setBidAmount(e.target.value);
  };

  
  const getBalance = async () => {
    if (queryClient) {
      const balance = await queryClient?.getBalance(
        accounts[0].address,
        "usei"
      );
      setBalance((balance.amount / DECIMAL).toFixed(3));
    }
  };

  const bidHandle = async () => {
    if(accounts.length <= 0) {
      return toast.warning("Please connect the wallet", { position: toast.POSITION.TOP_RIGHT, autoClose: 3000, });
    }

    if(bidAmount <= 0) {
      return toast.warning("Wrong price", { position: toast.POSITION.TOP_RIGHT, autoClose: 3000, });
    }

    if(!checkedTerm) {
      return toast.warning("Please check Terms", { position: toast.POSITION.TOP_RIGHT, autoClose: 3000,  });
    }

    if(loading) {
      return toast.warning("Can't click twice", { position: toast.POSITION.TOP_RIGHT, autoClose: 3000, });
    }

    const amount = bidAmount * DECIMAL;

    setLoading(true);

    let id = toast.loading("Bidding...", { position: toast.POSITION.TOP_RIGHT, autoClose: 3000, });


    const res = await makeBidHandle(signingClient, accounts[0].address,
      {
        ...bidData,
        price: amount,
    });
    if (res.success) {
      const bidParam = {...bidData, address: accounts[0].address, price: amount, }
      await createBid(bidParam);
      await updateBidsData();
      toast.update(id, { render: "Bided successfully", type: "success", autoClose: 2000, isLoading: false, });
      dispatch(bidsModalHide())
    } else {
      toast.update(id, { render: "Got Error", type: "error", autoClose: 2000, isLoading: false,  });
    }

    setLoading(false);
  }

  const updateBidsData = async () => {
    const data = {
      collection: window.location.pathname.split("/")[2],
      assetid: window.location.pathname.split("/")[3],
      subquery: 0,
    };

    const response = await getBids(data);
    console.log("bid details data: ", response);
    dispatch(updateNftBids(response));
  }

  useEffect(() => {
    if (accounts.length > 0) {
      getBalance();
    }
  }, [accounts, queryClient]);

  
  return (
    <div>
      <div className={bidsModal ? "modal fade show block" : "modal fade"}>
        <div className="modal-dialog max-w-2xl">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="placeBidLabel">
                Place Bid
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => { dispatch(bidsModalHide()); setLoading(false); }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="24"
                  height="24"
                  className="fill-jacarta-700 h-6 w-6 dark:fill-white"
                >
                  <path fill="none" d="M0 0h24v24H0z"></path>
                  <path d="M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z"></path>
                </svg>
              </button>
            </div>

            {/* <!-- Body --> */}
            <div className="modal-body p-6">
              <div className="mb-2 flex items-center justify-between">
                <span className="font-display text-jacarta-700 text-sm font-semibold dark:text-white">
                  Price
                </span>
              </div>

              <div className="dark:border-jacarta-600 border-jacarta-100 relative mb-2 flex items-center overflow-hidden rounded-lg border">
                <div className="border-jacarta-100 bg-jacarta-50 flex flex-1 items-center self-stretch border-r px-2">
                  <span>
                    <svg className="icon icon-ETH mr-1 h-5 w-5">
                      <use xlinkHref="/icons.svg#icon-ETH"></use>
                    </svg>
                  </span>
                  <span className="font-display text-jacarta-700 text-sm">
                    SEI
                  </span>
                </div>

                <input
                  type="number"
                  className="focus:ring-accent h-12 w-full flex-[3] border-0 focus:ring-inse dark:text-jacarta-700"
                  placeholder="Amount"
                  value={bidAmount}
                  onChange={(e) => handleBidAmount(e)}
                />

                <div className="bg-jacarta-50 border-jacarta-100 flex flex-1 justify-end self-stretch border-l dark:text-jacarta-700">
                  <span className="self-center px-2 text-sm">${(bidAmount * seiPrice).toFixed(3)}</span>
                </div>
              </div>

              <div className="text-right">
                <span className="dark:text-jacarta-400 text-sm">
                  Balance: {balance} SEI
                </span>
              </div>

              {/* <!-- Terms --> */}
              <div className="mt-4 flex items-center space-x-2">
                <input
                  type="checkbox"
                  id="terms"
                  onClick={(e)=>{
                    console.log(e.target)
                    if(e.target.checked) setCheckedTerm(true) 
                    else setCheckedTerm(false)}
                  }
                  className="checked:bg-accent dark:bg-jacarta-600 text-accent border-jacarta-200 focus:ring-accent/20 dark:border-jacarta-500 h-5 w-5 self-start rounded focus:ring-offset-0"
                />
                <label
                  htmlFor="terms"
                  className="dark:text-jacarta-200 text-sm"                 
                >
                  By checking this box, I agree to {"Nut Markets"}{" "}
                  <a href="#" className="text-accent">
                    Terms of Service
                  </a>
                </label>
              </div>
            </div>
            {/* <!-- end body --> */}

            <div className="modal-footer">
              <div className="flex items-center justify-center space-x-4">
                <button
                  type="button"
                  onClick={bidHandle}
                  className="bg-accent shadow-accent-volume hover:bg-accent-dark rounded-full py-3 px-8 text-center font-semibold text-white transition-all"
                >
                  Place Bid
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BidsModal;
